export default __webpack_public_path__ + "static/media/logo.2e775a61.svg";